import { createSelector } from 'reselect';

import { AppState } from '../../store/models/app-state';

const getDemandsOverviewRequesting = (state: AppState) => state.demands.overview.requesting;
const getDemandsDetailRequesting = (state: AppState) => state.demands.detail.requesting;
const getUserRequesting = (state: AppState) => state.contactsLogins.requestingUser;
const getAccountRequesting = (state: AppState) => state.account.requestingAccount;
const getBonusSettlementsRequesting = (state: AppState) => state.bonusSettlements.overview.requesting;
const getBonusSettlementDetailRequesting = (state: AppState) => {
    return (
        state.bonusSettlements.detail.requestingBonusSettlementSuppliers ||
        state.bonusSettlements.detail.requestingBonusSettlementDetails
    );
};

export const isRequesting = createSelector(
    [
        getDemandsOverviewRequesting,
        getUserRequesting,
        getAccountRequesting,
        getDemandsDetailRequesting,
        getBonusSettlementsRequesting,
        getBonusSettlementDetailRequesting,
    ],
    (
        requestingDemandsOverview,
        requestingUser,
        requestingAccount,
        requestingDemandsDetail,
        requestingBonusSettlementsOverview,
        requestingBonusSettlementDetail
    ) => {
        return (
            requestingDemandsOverview ||
            requestingUser ||
            requestingAccount ||
            requestingDemandsDetail ||
            requestingBonusSettlementsOverview ||
            requestingBonusSettlementDetail
        );
    }
);
